import { defineRule, configure } from 'vee-validate'
import { required, min, max } from '@vee-validate/rules'
import { setLocale, localize } from '@vee-validate/i18n';
import { ref, inject } from "vue";



const plugin = {

    install(app) {


        defineRule('required', required)
        defineRule('min', min)
        defineRule('max', max)
        configure({
            generateMessage: localize({
                en: {
                    messages: {
                        required: '{field} is required',

                    },
                    names: {
                        firstName: 'first name',
                    },
                },
                ja: {
                    messages: {
                        required: '{field}は必須です',

                    },
                    names: {
                        firstName: '苗字',
                    },
                },
            }),
        });

        // configure({
        //     generateMessage: localize({
        //         en: {
        //             messages: {
        //                 max: '{field} needs less than 8 letters',
        //                 min: '{field} needs at least 3 letters',
        //             },
        //             names: {
        //                 email: 'email'
        //             },
        //         },
        //         ja: {
        //             messages: {
        //                 max: '{field}は最大8文字にしてください',
        //                 min: '{field}は三文字必要です',
        //             },
        //             names: {
        //                 email: 'メールアドレス'
        //             },
        //         },
        //     }),
        // });

        const locale = ref("en")
        const updateValidationLocale = (newLocale) => {
            setLocale(newLocale)
            locale.value = newLocale
        };
        app.provide("updateValidationLocale", updateValidationLocale);
        app.provide("locale", locale);
    },
};

export default plugin;



// defineRule('required', required)
// // defineRule('required', (val) => {
// //     return required(val) ? true : 'required'
// // })
// // defineRule('min', (val, params) => {
// //     return min(val, params) ? true : 'min'
// // })

// defineRule('min', min)
// defineRule('max', max)
// configure({
//     generateMessage: localize({
//         en: {
//             messages: {
//                 required: '{field} is required',

//             },
//             names: {
//                 firstName: 'first name',
//             },
//         },
//         ja: {
//             messages: {
//                 required: '{field}は必須です',

//             },
//             names: {
//                 firstName: '苗字',
//             },
//         },
//     }),
// });

// configure({
//     generateMessage: localize({
//         en: {
//             messages: {
//                 max: '{field} needs less than 8 letters',
//                 min: '{field} needs at least 3 letters',
//             },
//             names: {
//                 email: 'email'
//             },
//         },
//         ja: {
//             messages: {
//                 max: '{field}は最大8文字にしてください',
//                 min: '{field}は三文字必要です',
//             },
//             names: {
//                 email: 'メールアドレス'
//             },
//         },
//     }),
// });
// setLocale('ja')